export type ProfileTab = "subscription" | "payment" | "inquiry" | "edit" | "withdraw";

export const PROFILE_MENU_ITEMS = [
  { id: "subscription" as const, label: "내 구독 현황" },
  { id: "payment" as const, label: "결제 내역" },
  { id: "inquiry" as const, label: "내 문의" },
  { id: "edit" as const, label: "회원 정보 수정" },
  { id: "withdraw" as const, label: "회원 탈퇴" },
];

export const WITHDRAWAL_WARNINGS = [
  "회원에서 탈퇴하시면 현재 사용 중인 계정은 즉시 이용이 중단되며, 해당 계정으로 로그인되어 있던 모든 디바이스에서도 자동으로 로그아웃됩니다.",
  "탈퇴된 계정은 복구가 불가능하며, 계정에 연결된 모든 정보와 이용 기록도 더 이상 조회할 수 없습니다.",
  "탈퇴 후에도 GGP 서비스 재가입은 가능하지만, 탈퇴 후 6개월이 지나지 않은 계정의 이메일 주소는 재사용할 수 없습니다.",
  "따라서 재가입을 원하실 경우, 새로운 이메일 주소로 가입해주셔야 합니다.",
];
